<template>
  <div class="container">
    <b-row>
      <!-- PRESENTACION DEL MINISTRO -->
      <b-col class="section-button">
        <b-button
          class="decoration-button"
          :to="{
            name: 'ministerio',
            params: { idServicio: userData.servicioId },
          }"
          :disabled="checkPerm(1)"
        >
          <Ministro />
          Presentación del Ministro
          <i
            v-if="presentacionMinistro"
            class="bx bxs-check-circle"
            style="color:#e0e0e0"
          ></i>
          <i
            v-if="presentacionMinistroF"
            class="bx bxs-check-circle"
            style="color:#24c6ab"
          ></i>
        </b-button>
      </b-col>
      <!-- PRESENTACION DEL SERVICIO -->
      <b-col class="section-button"
        ><b-button
          class="decoration-button"
          :to="{
            name: 'servicios',
            params: { idServicio: userData.servicioId },
          }"
          :disabled="checkPerm(2)"
        >
          <PServicio /> Presentación del Servicio
          <i
            v-if="presentacionServicio"
            class="bx bxs-check-circle"
            style="color:#e0e0e0"
          ></i>
          <i
            v-if="presentacionServicioF"
            class="bx bxs-check-circle"
            style="color:#24c6ab"
          ></i> </b-button
      ></b-col>

      <!-- RESULTADO DE LA GESTION-->

      <b-col class="section-button"
        ><b-button
          class="decoration-button"
          :to="{
            name: 'programaGobierno',
            params: { idServicio: userData.servicioId },
          }"
          :disabled="checkPerm(3)"
        >
          <RGestion />Resultado de la Gestión
          <i
            v-if="resultadoGestion"
            class="bx bxs-check-circle"
            style="color:#e0e0e0"
          ></i>
          <i
            v-if="resultadoGestionF"
            class="bx bxs-check-circle"
            style="color:#24c6ab"
          ></i> </b-button
      ></b-col>

      <!-- DesafiosN-->
      <b-col class="section-button"
        ><b-button
          class="decoration-button"
          :to="{ name: 'desafio', params: { idServicio: userData.servicioId } }"
          :disabled="checkPerm(4)"
        >
          <DesafiosIcon />
          <span style="margin-left:20px"
            >Desafíos

            <i
              v-if="desafiosF"
              class="bx bxs-check-circle"
              style="color:#e0e0e0"
            ></i>
            <i
              v-if="desafiosB"
              class="bx bxs-check-circle"
              style="color:#24c6ab"
            ></i>
          </span> </b-button
      ></b-col>
    </b-row>
    <!-- SEGUNDA FILA -->
    <b-row>
      <!--Recursos Humanos-->
      <b-col class="section-button">
        <b-button
          class="decoration-button"
          :to="{
            name: 'rHumanos',
            params: { idServicio: userData.servicioId },
          }"
          :disabled="checkPerm(5)"
          ><RHumanos />
          <span style="margin-left:5px"
            >Recursos Humanos
            <i
              v-if="rHumanos"
              class="bx bxs-check-circle"
              style="color:#e0e0e0"
            ></i>
            <i
              v-if="rHumanosF"
              class="bx bxs-check-circle"
              style="color:#24c6ab"
            ></i
          ></span>
        </b-button>
      </b-col>
      <!--Recursos Financieros-->
      <b-col class="section-button">
        <b-button
          class="decoration-button"
          :to="{
            name: 'rfinancieross',
            params: { idServicio: userData.servicioId },
          }"
          :disabled="checkPerm(6)"
          ><RFinancieros /> Recursos Financieros
          <i
            v-if="rFinanciero"
            class="bx bxs-check-circle"
            style="color:#e0e0e0"
          ></i>
          <i
            v-if="rFinancieroF"
            class="bx bxs-check-circle"
            style="color:#24c6ab"
          ></i
        ></b-button>
      </b-col>
      <!--RIndicadoress-->
      <b-col class="section-button">
        <b-button
          class="decoration-button"
          :to="{
            name: 'indicador',
            params: { idServicio: userData.servicioId },
          }"
          :disabled="checkPerm(7)"
          ><Barra />
          <span style="margin-left:18px"
            >Indicadores
            <i
              v-if="indicador"
              class="bx bxs-check-circle"
              style="color:#24c6ab"
            ></i>
          </span>
        </b-button>
      </b-col>
      <!--Compromisos-->
      <b-col class="section-button"
        ><b-button
          class="decoration-button"
          :to="{
            name: 'compromisos',
            params: { idServicio: userData.servicioId },
          }"
          :disabled="checkPerm(8)"
          ><Compromisos />
          <span style="margin-left:15px"
            >Compromisos
            <i
              v-if="compromisos"
              class="bx bxs-check-circle"
              style="color:#e0e0e0"
            ></i>
            <i
              v-if="compromisosF"
              class="bx bxs-check-circle"
              style="color:#24c6ab"
            ></i
          ></span> </b-button
      ></b-col>
    </b-row>

    <!-- TERCERA FILA -->
    <b-row>
      <!-- EVALUACIONES -->
      <b-col class="section-button">
        <b-button
          class="decoration-button"
          :to="{
            name: 'informeprograma',
            params: { idServicio: userData.servicioId },
          }"
          :disabled="checkPerm(9)"
          ><Evaluacion />
          <span style="margin-left:13px"
            >Evaluaciones
            <i
              v-if="evaluaciones"
              class="bx bxs-check-circle"
              style="color:#e0e0e0"
            ></i>
            <i
              v-if="evaluacionesF"
              class="bx bxs-check-circle"
              style="color:#24c6ab"
            ></i
          ></span>
        </b-button>
      </b-col>
      <!-- INCENTIVO INSTITUCIONAL -->
      <!-- :disabled="checkPerm(10)" -->
      <b-col class="section-button"
        ><b-button
          class="decoration-button"
          :disabled="checkPerm(10)"
          :to="{
            name: 'iinstitucional',

            params: { idServicio: userData.servicioId },
          }"
          ><IInstitucional />Incentivo Institucional
          <i class="bx bxs-check-circle" style="color:#24c6ab"></i></b-button
      ></b-col>
      <!-- INCENTIVO INSTITUCIONAL -->
      <b-col class="section-button">
        <b-button
          class="decoration-button"
          :to="{
            name: 'icolectivo',
            params: { idServicio: userData.servicioId },
          }"
          :disabled="checkPerm(11)"
          ><IColectivo /><span style="margin-left:4px"
            >Incentivo Colectivo
            <i
              v-if="incetivoColectivo"
              class="bx bxs-check-circle"
              style="color:#e0e0e0"
            ></i>
            <i
              v-if="incetivoColectivoF"
              class="bx bxs-check-circle"
              style="color:#24c6ab"
            ></i
          ></span>
        </b-button>
      </b-col>
      <!-- GENERO -->
      <b-col class="section-button"
        ><b-button
          class="decoration-button"
          :to="{ name: 'genero', params: { idServicio: userData.servicioId } }"
          :disabled="checkPerm(12)"
        >
          <Igualdad />
          <span style="margin-left:4px"
            >Equidad de Género
            <i
              v-if="genero"
              class="bx bxs-check-circle"
              style="color:#e0e0e0"
            ></i>
            <i
              v-if="generoF"
              class="bx bxs-check-circle"
              style="color:#24c6ab"
            ></i
          ></span> </b-button
      ></b-col>
    </b-row>

    <b-row>
      <b-col class="section-button">
        <b-button
          class="decoration-button"
          :to="{
            name: 'leyesTramite',
            params: { idServicio: userData.servicioId },
          }"
          :disabled="checkPerm(13)"
          ><LeyesIcon />
          <span style="margin-left:30px"
            >Leyes
            <i
              v-if="leyes"
              class="bx bxs-check-circle"
              style="color:#e0e0e0"
            ></i>
            <i
              v-if="leyesF"
              class="bx bxs-check-circle"
              style="color:#24c6ab"
            ></i>
          </span>
        </b-button>
      </b-col>
      <b-col class="section-button"
        ><b-button
          class="decoration-button"
          :to="{ name: 'premios', params: { idServicio: userData.servicioId } }"
          :disabled="checkPerm(14)"
          ><Reconocimiento />Premios y Reconocimientos
          <i
            v-if="premios"
            class="bx bxs-check-circle"
            style="color:#e0e0e0"
          ></i>
          <i
            v-if="premiosF"
            class="bx bxs-check-circle"
            style="color:#24c6ab"
          ></i></b-button
      ></b-col>
      <b-col class="section-button">
        <b-button
          class="decoration-button"
          :disabled="checkPerm(15)"
          :to="{
            name: 'oservicio',
            params: { idServicio: userData.servicioId },
          }"
          ><OServicio />Organigrama de Servicios

          <i
            v-if="oServicio"
            class="bx bxs-check-circle"
            style="color:#24c6ab"
          ></i
        ></b-button>
      </b-col>

      <!-- :disabled="checkPerm(16)" -->
      <b-col class="section-button"
        ><b-button
          class="decoration-button"
          :disabled="checkPerm(17)"
          :to="{
            name: 'oministerio',
            params: { idServicio: userData.servicioId },
          }"
          ><OMinisterio /> Organigrama de Ministerio
          <i class="bx bxs-check-circle" style="color:#24c6ab"></i></b-button
      ></b-col>
    </b-row>
  </div>
</template>

<script>
import Ministro from "../../../components/icons/button/Ministro.vue";
import axios from "axios";
import PServicio from "../../../components/icons/button/PServicio.vue";
import RGestion from "../../../components/icons/button/RGestion.vue";
import DesafiosIcon from "../../../components/icons/button/DesafiosIcon.vue";
import RHumanos from "../../../components/icons/button/RHumanos.vue";
import RFinancieros from "../../../components/icons/button/RFinancieros.vue";
import Barra from "../../../components/icons/button/Barra";
import Compromisos from "../../../components/icons/button/Compromisos";
import Evaluacion from "../../../components/icons/button/Evaluacion";
import IInstitucional from "../../../components/icons/button/IInstitucional";
import IColectivo from "../../../components/icons/button/IColectivo";
import Igualdad from "../../../components/icons/button/Igualdad";
import LeyesIcon from "../../../components/icons/button/LeyesIcon.vue";
import OMinisterio from "../../../components/icons/button/OMinisterio.vue";
import Reconocimiento from "../../../components/icons/button/Reconocimiento.vue";
import OServicio from "../../../components/icons/button/OServicio";

export default {
  components: {
    Ministro,
    PServicio,
    RGestion,
    DesafiosIcon,
    RHumanos,
    RFinancieros,
    Barra,
    Compromisos,
    Evaluacion,
    IInstitucional,
    IColectivo,
    Igualdad,
    LeyesIcon,
    OMinisterio,
    Reconocimiento,
    OServicio,
  },
  data() {
    return {
      // PRESENTACION SERVICIO
      presentacionMinistro: false,
      presentacionMinistroF: false,
      // PRESENTACION SERVICIO
      presentacionServicio: false,
      presentacionServicioF: false,
      //Resultados de la gestion
      resultadoGestion: false,
      resultadoGestionF: false,
      //DESAFIOS
      desafiosB: false,
      desafiosF: false,
      //Recursos humanos
      rHumanos: false,
      rHumanosF: false,
      //Recursos Financieros
      rFinanciero: false,
      rFinancieroF: false,
      //Indicador
      indicador: false,
      //compromisos
      compromisos: false,
      compromisosF: false,
      //evaluaciones:
      evaluaciones: false,
      evaluacionesF: false,
      //IncentivoInstitucional
      incentivo: false,
      //incentivoColectivo
      incetivoColectivo: false,
      incetivoColectivoF: false,
      //genero
      genero: false,
      generoF: false,
      //leyes
      leyes: false,
      leyesF: false,
      //premiois
      premios: false,
      premiosF: false,
      //Organigrama
      oServicio: false,
      oMinisterio: false,
    };
  },
  props: ["userData"],
  methods: {
    checkPerm: function(idPerm) {
      const { perfilId } = this.userData;
      if (
        perfilId === 1 ||
        perfilId === 6 ||
        perfilId === 2 ||
        perfilId === 4 ||
        perfilId === 3
      ) {
        // if (idPerm === 1 || idPerm === 17) {
        //   if (perfilId === 1) return false;
        //   if (perfilId === 6) {
        //     return false;
        //   } else {
        //     return true;
        //   }
        // }
        return false;
      } else {
        if (this.userData.permisos.find((p) => p.permisoId === idPerm)) {
          return false;
        } else {
          return true;
        }
      }
    },

    presentacionMinistroFunction: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${process.env.VUE_APP_ANIO}&nombre=presentacion_ministro`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data.elaboracion === "finalizado") {
          this.presentacionMinistroF = true;
          this.presentacionMinistro = false;
        } else if (res.data.elaboracion === "borrador") {
          this.presentacionMinistroF = false;
          this.presentacionMinistro = true;
        }
      } catch (error) {
        console.log(error);
      }
    },

    presentacionServicioFunction: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${process.env.VUE_APP_ANIO}&nombre=presentacion_servicio`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data.elaboracion === "finalizado") {
          this.presentacionServicioF = true;
          this.presentacionServicio = false;
        } else if (res.data.elaboracion === "borrador") {
          this.presentacionServicioF = false;
          this.presentacionServicio = true;
        }
      } catch (error) {
        console.log(error);
      }
    },

    resultadoDeLaGestionFuntion: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${process.env.VUE_APP_ANIO}&nombre=resultados_gestion`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        const ress = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${process.env.VUE_APP_ANIO}&nombre=avance_gestion`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        if (
          res.data.elaboracion === "finalizado" ||
          ress.data.elaboracion === "finalizado"
        ) {
          this.resultadoGestionF = true;
          this.resultadoGestio = false;
        } else if (
          res.data.elaboracion === "borrador" ||
          ress.data.elaboracion === "borrador"
        ) {
          this.resultadoGestionF = false;
          this.resultadoGestion = true;
        }
      } catch (error) {
        console.log(error);
      }
    },

    desafiosFunction: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${process.env.VUE_APP_ANIO}&nombre=desafios`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data.elaboracion === "finalizado") {
          this.desafiosB = true;
          this.desafiosF = false;
        } else if (res.data.elaboracion === "borrador") {
          this.desafiosB = false;
          this.desafiosF = true;
        }
      } catch (error) {
        console.log(error);
      }
    },

    recursosHumanosFunction: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${process.env.VUE_APP_ANIO}&nombre=recursos_humanos`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data.elaboracion === "finalizado") {
          this.rHumanosF = true;
          this.rHumanos = false;
        } else if (res.data.elaboracion === "borrador") {
          this.rHumanosF = false;
          this.rHumanos = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    recursosFinancierosFunction: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${process.env.VUE_APP_ANIO}&nombre=recursos_financieros`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data.elaboracion === "finalizado") {
          this.rFinancieroF = true;
          this.rFinanciero = false;
        } else if (res.data.elaboracion === "borrador") {
          this.rFinancieroF = false;
          this.rFinanciero = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    indicadoresFunction: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/anexos/anexo/public_list/?anexo=4&servicio=${this.$route.params.idServicio}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data[0].datos.modificado !== undefined) this.indicador = true;
      } catch (error) {
        console.log(error);
      }
    },
    compromisosFunction: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=2022&nombre=compromisos`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data.elaboracion === "finalizado") {
          this.compromisosF = true;
          this.compromisos = false;
        } else if (res.data.elaboracion === "borrador") {
          this.compromisosF = false;
          this.compromisos = true;
        }
        console.log(res.data);
      } catch (error) {
        console.log(error);
      }
    },
    EvaluacionesFunction: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${process.env.VUE_APP_ANIO}&nombre=evaluaciones`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data.elaboracion === "finalizado") {
          this.evaluacionesF = true;
          this.evaluaciones = false;
        } else if (res.data.elaboracion === "borrador") {
          this.evaluacionesF = false;
          this.evaluaciones = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    incentivoInstitucionalFunction: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/anexos/anexo/public_list/?anexo=7&servicio=${this.$route.params.idServicio}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data[0].datos.modificado !== undefined) this.incentivo = true;
      } catch (error) {
        console.log(error);
      }
    },
    incentivoColectivoFunction: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${process.env.VUE_APP_ANIO}&nombre=evaluaciones`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data.elaboracion === "finalizado") {
          this.incetivoColectivoF = true;
          this.incetivoColectivo = false;
        } else if (res.data.elaboracion === "borrador") {
          this.incetivoColectivoF = false;
          this.incetivoColectivo = true;
        }
        console.log(res.data);
      } catch (error) {
        console.log(error);
      }
    },
    generoFunction: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${process.env.VUE_APP_ANIO}&nombre=genero`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data.elaboracion === "finalizado") {
          this.generoF = true;
          this.genero = false;
        } else if (res.data.elaboracion === "borrador") {
          this.generoF = false;
          this.genero = true;
        }
        console.log(res.data);
      } catch (error) {
        console.log(error);
      }
    },
    leyesFunction: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${process.env.VUE_APP_ANIO}&nombre=leyes`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data.elaboracion === "finalizado") {
          this.leyesF = true;
          this.leyes = false;
        } else if (res.data.elaboracion === "borrador") {
          this.leyesF = false;
          this.leyes = true;
        }
        console.log(res.data);
      } catch (error) {
        console.log(error);
      }
    },
    premiosFunction: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${process.env.VUE_APP_ANIO}&nombre=premios_reconocimientos`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data.elaboracion === "finalizado") {
          this.premiosF = true;
          this.premios = false;
        } else if (res.data.elaboracion === "borrador") {
          this.premiosF = false;
          this.premios = true;
        }
        console.log(res.data);
      } catch (error) {
        console.log(error);
      }
    },
    oSerrvicioFunction: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/servicios/${this.$route.params.idServicio}/`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data.files) {
          this.oServicio = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    oMinisterioFunction: async function() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/ministerios/${this.$route.params.idServicio}/`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        if (res.data.files) {
          this.oMinisterio = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },

  mounted() {
    this.presentacionMinistroFunction();
    this.presentacionServicioFunction();
    this.resultadoDeLaGestionFuntion();
    this.desafiosFunction();
    this.recursosHumanosFunction();
    this.recursosFinancierosFunction();
    this.indicadoresFunction();
    this.compromisosFunction();
    this.EvaluacionesFunction();
    this.incentivoInstitucionalFunction();
    this.incentivoColectivoFunction();
    this.generoFunction();
    this.leyesFunction();
    this.premiosFunction();
    this.oSerrvicioFunction();
    this.oMinisterioFunction();

  },
};
</script>

<style scoped>
.row {
  margin: 0;
  text-align: center;
  background: #fff;
  /* margin: 30px; */
}

.decoration-button {
  display: flex;
  background: #3d185f;
  text-align: center;
  border: none;
  height: 45px;
  width: 176px;
  font-size: 11px;
  border-radius: 40px;
  align-items: center;
}

.decoration-button:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 25px;
  background: #052333;
  color: #fff !important;
}

.section-button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 15px 0;
}

.btn-check:focus + .btn-secondary,
.btn-secondary:focus {
  background: #052333;
}

</style>
